import React from 'react';

function SingleChoiceViewMode(props) {
    const buildChoicesContainer = () => {
        const questionId = props.questionData.id;
        const choices = props.questionData.choices;
        return choices.map((choice, idx) => {
            const elemKey = "question_" + questionId + "_choice_" + idx;
            return (
                <label key={elemKey} className="questionaire__builder__question__form__check" htmlFor={questionId + "_" + choice.value}>
                    <input className="questionaire__builder__question__form__check__radio" name={"question_" + questionId} type="radio" id={questionId + "_" + choice.value}/>
                    <span className="questionaire__builder__question__form__check__round"> </span>
                    <span className="questionaire__builder__question__form__check__text">{choice.label}</span>
                </label>
            );
        });
    };

    return (
        <div className="questionaire__builder__question__form">
            {buildChoicesContainer()}
        </div>
    );
}

export default SingleChoiceViewMode;